import produce from 'immer';

import { QuizLimit } from '../../../../api/quiz';

export const updateQuizLimit = (newQuizCount: number) =>
  produce((quizLimit: QuizLimit) => {
    quizLimit.currentQuizCount = newQuizCount;
    return quizLimit;
  });
